<template>
  <div class="home">
    <div><img class="logo_home" alt="OrePorMim" src="../assets/img/logo_v3-negative.png" /></div>
    <div class="screenshots">
    </div>
    <div><a href="https://play.google.com/store/apps/details?id=net.xupisco.prayforme"><img class="googleplay" alt="Download na GooglePlay" src="../assets/img/google-play-badge.png" /></a></div>
    <img src="../assets/img/logo_og.png" style="display: none;" />
  </div>

</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
    name: 'home',
    components: {
        HelloWorld
    },
    metaInfo() {
        return {
            meta: [
                {'property': 'og:url', 'content': 'https://orepormim.com.br/'},
                {'property': 'og:title', 'content': 'OrePorMim'},
                {'property': 'og:type', 'content': 'article'},
                {'property': 'og:description', 'content': 'Faça seus pedidos de oração e receba a benção da comunidade para ajudar a realizar os seus objetivos ou enfrentar desafios.' },
                {'property': 'og:image', 'content': 'https://orepormim.com.br/img/logo_og.png'},
                {'property': 'og:image:width', 'content': '1200'},
                {'property': 'og:image:height', 'content': '630'},
                {'property': 'fb:app_id', 'content': '492862741151697'},

                {'property': 'twitter:card', 'content': 'summary_large_image'},
                {'property': 'twitter:site', 'content': '@OrePorMim'},
                {'property': 'twitter:title', 'content': 'OrePorMim'},
                {'property': 'twitter:description', 'content': 'Faça seus pedidos de oração e receba a benção da comunidade para ajudar a realizar os seus objetivos ou enfrentar desafios.' },
                {'property': 'twitter:image', 'content': 'https://orepormim.com.br/img/logo_og.png'},
            ]
        }
    }

}
</script>

<style lang="scss" scoped>
img.logo_home {
    width: 300px;
    position: fixed;
    z-index: 10;
    right: 30px;
    top: 20px;
}

img.googleplay {
    position: fixed;
    width: 200px;
    z-index: 10;
    bottom: 20px;
    left: 20px;
}

.screenshots {
    background-image: url('../assets/img/mockup_01.jpg');
    background-size: cover;
    background-position-x: 50% !important;
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    top: 0;
}

.screenshot {
    img {
        width: 100%;
        box-shadow: 0px 0px 11px 2px rgba(0,0,0,0.3);
    }
}
</style>

